/**
 * DotsFull - Dot pattern background with full coverage
 *
 * Creates a repeating dot pattern that covers the entire area with no fade.
 * Uses theme variables for automatic light/dark mode support.
 *
 * @example
 * ```tsx
 * <section className="relative">
 *   <DotsFull />
 *   <div className="relative z-10">Content here</div>
 * </section>
 * ```
 */
export function DotsFull() {
  return (
    <div
      className="absolute inset-0 z-0"
      style={{
        backgroundImage: `radial-gradient(circle, var(--border) 1px, transparent 1px)`,
        backgroundSize: '24px 24px',
      }}
    />
  )
}
